export const ActionTypes = {
    setUserInfo: "SETSALONSYTEMUSERINFO"
} as const